<template>
    <main id="machine-sheet-accessories" v-if="displayContent">
        <div class="wrapper">
            <template v-if="filteredResults.length > 0">
                <h2 class="title is-2">
                    <span :class="brandColor">{{ results.length }}</span> {{ $t("accessories_compatibles_with_this_machine") }}
                </h2>
                <div class="columns no-bottom-margin is-vcentered actions">
                    <div class="column is-narrow category-filter-label-container">
                        <label class="category-filter-label">{{ $t("filter_by_application") }}</label>
                    </div>
                    <div class="column">
                        <b-select v-model="filterApplication" size="is-large" rounded>
                            <option
                                v-for="application in applicationsFilter"
                                :value="application.code"
                                :key="application.code"
                            >{{ application.label }}</option>
                        </b-select>
                    </div>
                    <div class="column is-narrow pagination-top">
                        <div class="pagination-container">
                            <b-pagination
                                v-if="filteredResults.length > itemsPerPage"
                                :total="filteredResults.length"
                                :current.sync="currentPage"
                                order="is-centered"
                                size="is-medium"
                                :simple="isPhone"
                                :per-page="itemsPerPage"
                                rounded>
                            </b-pagination>
                        </div>
                    </div>
                </div>
                <div class="item-list">
                    <card-accessory
                        v-for="(result, index) in paginatedResults"
                        :key="index"
                        class="result-item"
                        :datas="result"
                    />
                </div>

                <div class="pagination-bottom">
                    <div class="pagination-container">
                        <b-pagination
                            v-if="filteredResults.length > itemsPerPage"
                            :total="filteredResults.length"
                            :current.sync="currentPage"
                            order="is-centered"
                            size="is-medium"
                            :simple="isPhone"
                            :per-page="itemsPerPage"
                            rounded>
                        </b-pagination>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="content-available-soon">
                    {{ $t('content_available_soon') }}
                </div>
            </template>
        </div>
    </main>
</template>

<script>
    import { mapState } from 'vuex'

    //import attributeService from "@/services/akeneo/attribute";
    import productService from "@/services/serli/product";
    //import productModelService from "@/services/akeneo/productModel";

    import CardAccessory from "@/components/Card/CardAccessorySummary.vue"

    export default {
        name: 'MachineAccessoriesView',
        components: {
            CardAccessory,
        },
        data() {
            return {
                displayContent: false,
                results: [],
                currentPage: 1,
                filterApplication: null,
                applicationsFilter: [],
              machineApplications:[],
            }
        },
        computed: {
            ...mapState({
                productDatas: state => state.sheet.productDatas,
                isLargeDesktop: state => state.settings.isLargeDesktop,
                isSmallDesktop: state => state.settings.isSmallDesktop,
                isTablet: state => state.settings.isTablet,
                isPhone: state => state.settings.isPhone,
                applications: state=>state.settings.applications
            }),
            paginatedResults() {
                return this.filteredResults.slice(((this.currentPage-1)*this.itemsPerPage), (this.currentPage*this.itemsPerPage));
            },
            filteredResults(){
                let results = [];
                if(this.filterApplication)
                    results = this.results.filter(result => result.applications ? result.applications.includes(this.filterApplication) : null);
                else
                    results = this.results;

                results = results.sort(function(a, b){
                    if(a.label < b.label) { return -1; }
                    if(a.label > b.label) { return 1; }
                    return 0;
                })

                return results;
            },
            itemsPerPage() {
                if(this.isLargeDesktop)
                    return 15
                if(this.isSmallDesktop)
                    return 12
                if(this.isTablet)
                    return 9
                if(this.isPhone)
                    return 10
                return 18;
            },
        },
        created(){
            this.startLoading();
            this.getAccessories()
            .then(() => this.fetchApplications())
            .finally(() => {
                this.displayContent = true;
                this.stopLoading();
            });
        },
        activated(){
            if(this.$route.query.application)
                this.filterApplication = this.$route.query.application;
        },
        methods: {
         async fetchApplications(){
            this.stopLoading()

            this.productDatas.attachments_products.forEach((attachment) => {
              productService.show(attachment.code, {
                locale: this.localeKebabFormat,
                unit: this.unitType,
                country: this.country
              }).then((response) => {
                if (response.data.code === 200) {
                  let index=this.results.findIndex(x => x.code === response.data.data.identifier)
                  if(!this.results[index].applications) this.results[index].applications=response.data.data.applications
                  this.machineApplications=this.machineApplications.concat(response.data.data.applications)
                  this.machineApplications=[...new Set(this.machineApplications)]
                }
              }).finally(()=> {this.getApplicationsFilter()})
            })
          },
          async getAccessories() {
            this.results=this.productDatas.attachments_products;
          },
          async getApplicationsFilter() {

            let applicationsFilter = [{
              code: null,
              label: this.$t('all_xx')
            }]
            this.machineApplications.forEach((application)=>{
              var index=this.applications.findIndex(x => x.code == application)
              applicationsFilter.push(this.applications[index])
            })
            this.applicationsFilter=applicationsFilter
          }
        }
    }
</script>

<style lang="scss">
    #machine-sheet-accessories {
        padding-top: 35px;
        padding-bottom: 30px;

        .actions {
            margin-top: 30px;

            .category-filter-label-container {
                @media #{$mq_phone} {
                    padding-bottom: 0;
                }

                .category-filter-label {
                    font-size: 18px;
                    color: $medium-grey;
                }
            }
        }

        .item-list {
            margin: 0 -10px;
            display: flex;
            flex-wrap: wrap;
            align-items: center;

            @media #{$mq_phone} {
                margin: 0;
            }

            .result-item {
                flex: 0 0 calc((100%/6) - 20px);
                margin: 10px;

                @media #{$mq_large_desktop} {
                    flex: 0 0 calc((100%/5) - 20px);
                }

                @media #{$mq_small_desktop} {
                    flex: 0 0 calc((100%/4) - 20px);
                }

                @media #{$mq_tablet} {
                    flex: 0 0 calc((100%/3) - 20px);
                }

                @media #{$mq_phone} {
                    flex: 0 0 100%;
                    margin: 0 0 20px 0;
                }
            }
        }

        .pagination-top {
            text-align: right;

            .pagination-container {
                display: inline-block;
            }
        }

        .pagination-bottom {
            display: block;
            text-align: right;
            margin-top: 20px;

            .pagination-container {
                    display: inline-block;
            }
        }
    }
</style>

